export const environment = {
  production: false,
  // Used only by the Jenkins 'development' build configuration (deployed to
  // ghoulpool-dev.ghoulishmortals.com) — relative, since the API is
  // same-origin behind Apache's /api reverse proxy there too. Plain `ng serve`
  // on a developer's own machine uses environment.ts instead (localhost:4000).
  apiBaseUrl: '/api',
  // Umami website for the dev site — kept separate from production's so
  // test traffic doesn't mix into the real numbers.
  umamiWebsiteId: '74d51522-aa64-4355-9737-5dc695fb3298',
};
